import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Banner = styled.div<{ src?: string; withWhatsapp?: boolean }>`
  position: relative;
  padding: 25px 0 80px;
  color: ${(props) => props.theme.color.blue.default};
  background-color: ${(props) => props.theme.color.blue.lightBlue};

  ${(props) =>
    props.src &&
    `
  background: url(${props.src}) no-repeat center center;
  background-size: cover;
  `}

  ${mediaQuery('small')} {
    ${(props) => (props.withWhatsapp ? 'padding: 15px 0 30px;' : 'padding: 15px 0 65px;')}
  }
`;

export const BackWrapper = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 5px;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;

  & > *:not(:last-child) {
    margin-right: 5px;
  }
`;

export const Title = styled.h1`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  margin: 10px 0;
  ${responsiveFontSize(44, 6)}
`;

export const Subtitle = styled.h2`
  z-index: 1;
  position: relative;
  ${responsiveFontSize(22, 2)}
  font-weight: 500;
  margin: 0;
  margin-bottom: 20px;
`;

export const TagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TagsPrefix = styled.h2`
  z-index: 1;
  position: relative;
  ${responsiveFontSize(22, 2)}
  font-weight: 500;
  margin: 0;

  ${mediaQuery('small')} {
    display: none;
  }
`;

export const TagContainer = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: 7px;
  }
  flex-wrap: wrap;
`;

export const ForegroundLink = styled(Link)`
  z-index: 10000;
`;
